export default "__VITE_ASSET__43ebQDP7__"